import { useEffect } from 'react';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { AppRouter } from '@/app/routes/AppRouter';
import { Toaster } from '@/components/ui/sonner';

export function App() {
  useEffect(() => {
    // Hide the initial page loader after React has mounted
    const loader = document.getElementById('page-loader');
    if (loader) {
      loader.classList.add('loaded');
      // Remove from DOM after transition completes
      setTimeout(() => {
        loader.remove();
      }, 300);
    }
  }, []);

  return (
    <ThemeProvider defaultTheme="system" storageKey="orbii-admin-ui-theme">
      <QueryProvider>
        <AppRouter />
        <Toaster />
      </QueryProvider>
    </ThemeProvider>
  );
}
